import { render, staticRenderFns } from "./addSetmeal.vue?vue&type=template&id=65bdc339&scoped=true"
import script from "./addSetmeal.vue?vue&type=script&lang=ts"
export * from "./addSetmeal.vue?vue&type=script&lang=ts"
import style0 from "./addSetmeal.vue?vue&type=style&index=0&id=65bdc339&prod&lang=css"
import style1 from "./addSetmeal.vue?vue&type=style&index=1&id=65bdc339&prod&lang=scss"
import style2 from "./addSetmeal.vue?vue&type=style&index=2&id=65bdc339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bdc339",
  null
  
)

export default component.exports